import React from 'react';
import { connect } from 'react-redux';
import WAShareByEmailContent from '../components/pages/waiting-area/share-by-email/content';

function WAShareByEmailContainer(props) {
  return (
    <WAShareByEmailContent
      waURLEmailData={props.waURLEmailData}
      waitingArea={props.waitingArea}
      isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
      dispatch={props.dispatch}
    />
  );
}
function mapStateToProps(state) {
  return {
    waURLEmailData: state.waitingAreaReducer.waURLEmailData,
    isWAEntryPointAdditionalMsgAllowed: state.usersReducer.userProfile.isWAEntryPointAdditionalMsgAllowed,
  };
}

export default connect(mapStateToProps, null)(WAShareByEmailContainer);
